import { CoroutineDispatcherizb7p9bijexj as CoroutineDispatcher } from '../CoroutineDispatcher.mjs';
import { Delay9umexudtwyie as Delay } from '../Delay.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { get_DefaultDelay3q9fawcutqbnw as get_DefaultDelay } from '../CoroutineContext.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NamedDispatcherClass;
function NamedDispatcher() {
  if (NamedDispatcherClass === VOID) {
    class $ extends CoroutineDispatcher() {
      constructor(dispatcher, name) {
        super();
        var tmp = this;
        var tmp0_elvis_lhs = isInterface(dispatcher, Delay()) ? dispatcher : null;
        tmp.$$delegate_0__1 = tmp0_elvis_lhs == null ? get_DefaultDelay() : tmp0_elvis_lhs;
        this.dispatcher_1 = dispatcher;
        this.name_1 = name;
      }
      isDispatchNeeded_ft82v4_k$(context) {
        return this.dispatcher_1.isDispatchNeeded_ft82v4_k$(context);
      }
      dispatch_qa3n0o_k$(context, block) {
        return this.dispatcher_1.dispatch_qa3n0o_k$(context, block);
      }
      toString() {
        return this.name_1;
      }
      scheduleResumeAfterDelay_iugqq8_k$(timeMillis, continuation) {
        this.$$delegate_0__1.scheduleResumeAfterDelay_iugqq8_k$(timeMillis, continuation);
      }
      invokeOnTimeout_nj9oyy_k$(timeMillis, block, context) {
        return this.$$delegate_0__1.invokeOnTimeout_nj9oyy_k$(timeMillis, block, context);
      }
    }
    initMetadataForClass($, 'NamedDispatcher', VOID, VOID, [Delay()], [1]);
    NamedDispatcherClass = $;
  }
  return NamedDispatcherClass;
}
//region block: exports
export {
  NamedDispatcher as NamedDispatcher2rg47sbefduxc,
};
//endregion

//# sourceMappingURL=NamedDispatcher.mjs.map
